import Grid from '@mui/material/Grid';
import TextFieldMui from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { AccountingParameter } from '../../types';
import FrequencySelectFormInput from './FrequencySelectFormInput';
import { useContryName } from '../../hooks';
import { TextFieldFormInput } from '../FlexSalesForm';

const inputPropsReadOnly = { readOnly: true };
const inputPropsLength3 = { maxLength: 3 };
const inputPropsLength25 = { maxLength: 25 };

interface CompanyCodeEditFormProps {
  accountingParameter: AccountingParameter;
}

const MasterField = ({ accountingParameter }: CompanyCodeEditFormProps) => {
  const { t } = useTranslation();
  const countryName = useContryName({ countryId: accountingParameter.countryId });

  return (
    <Grid container flexDirection="row" spacing={1}>
      <Grid item xs>
        <TextFieldMui
          type="text"
          variant="standard"
          label={t('accountingParameters.columns.country')}
          value={countryName}
          inputProps={inputPropsReadOnly}
          fullWidth
        />
      </Grid>
      <Grid item xs>
        <TextFieldMui
          type="text"
          variant="standard"
          label={t('accountingParameters.columns.journalType')}
          value={accountingParameter.journalType}
          inputProps={inputPropsReadOnly}
          fullWidth
        />
      </Grid>
      <Grid item xs>
        <TextFieldFormInput
          name="source"
          label={t('accountingParameters.columns.source')}
          required
          inputProps={inputPropsLength25}
        />
      </Grid>
      <Grid item xs>
        <TextFieldFormInput
          name="category"
          label={t('accountingParameters.columns.category')}
          required
          inputProps={inputPropsLength25}
        />
      </Grid>
      <Grid item xs>
        <TextFieldFormInput
          name="categoryAlias"
          label={t('accountingParameters.columns.categoryAlias')}
          required
          inputProps={inputPropsLength3}
        />
      </Grid>
      <Grid item xs>
        <FrequencySelectFormInput
          name="frequency"
          label={t('accountingParameters.columns.frequency')}
          required
        />
      </Grid>
    </Grid>
  );
};

export default MasterField;
